/* eslint semi:0 */
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'
import { l } from '../providers/i18nProvider/i18nProvider'

function formatNumberToDoubleDigitString(number) {
  return `0${number}`.slice(-2)
}

export function toIsoStringDate(dateInstance) {
  const [dateString /*timeString*/, ,] = dateInstance.toISOString().split('T')
  return dateString
}

export const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24

export function isSameCalendarDay(date1, date2) {
  return date1.toDateString() === date2.toDateString()
}

export function getDateByTime(time) {
  return new Date(time.getFullYear(), time.getMonth(), time.getDate())
}

export function getDateByIso8601string(iso8601string) {
  const [year, month, day] = iso8601string.split('-').map(num => parseInt(num))
  return new Date(year, month - 1, day)
}

export function toHourMinute(...args) {
  // https://github.com/fnando/i18n-js#date-formatting
  return l('time.formats.hour_minute', ...args)
}

export function toHourMinuteFromParts({ dateString, timeString }) {
  // https://github.com/fnando/i18n-js#date-formatting
  return toHourMinute(`${dateString}T${timeString}`)
}

export function getCurrentIsoStringDate(date = new Date()) {
  const month = formatNumberToDoubleDigitString(date.getMonth() + 1)
  const day = formatNumberToDoubleDigitString(date.getDate())
  return `${date.getFullYear()}-${month}-${day}`
}

export function addDaysToDate(date, days) {
  var d = new Date()
  return d.setDate(date.getDate() + days)
}

const date = Object.assign(makeEmptyObj(), {
  DAY_IN_MILLISECONDS,
  isSameCalendarDay,
  getDateByTime,
  getDateByIso8601string,
  toHourMinute,
  toHourMinuteFromParts,
  toIsoStringDate,
  getCurrentIsoStringDate,
  addDaysToDate,
})

registerUtils({ date })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/date.js